package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun DarknessMetadata() {
    SpellMetadata(
        spellIndex = "darkness",
        castingTime = "1 action",
        range = "60 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.MATERIAL),
        material = "Bat fur and a drop of pitch or piece of coal.",
        duration = "Up to 10 minutes",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = "15-ft Sphere",
        concentration = true
    )
}
